import React from "react";
import clsx from "clsx";
import Row from "@gqlapp/base/Row";
import Col from "@gqlapp/base/Col";
import Box from "@mui/material/Box";
import { fontConfig as fontBase } from "./utils";
import Field from "@gqlapp/forms-client-react/FieldAdapter";
import RenderField from "@gqlapp/fields/RenderField";
import RenderSlider from "@gqlapp/fields/Slider";

export default function Font(props){
	let { maxFontSize, setFieldValue, name, values } = props;
	const fontConfig  = fontBase(props);
	
	return (<>
		<Box sx={{
			backgroundColor: '#ffffff',
			padding: '15px 15px 0',
			'& .MuiFormControl-root': {marginTop: 0, marginBottom: 0},
			'& .row': { marginBottom: '15px' }, '& .col': { minHeight: '40px' }
		}}>
			<Row small>
				<Col xs={'auto'} style={{maxWidth: '150px'}}>
					<Field {...fontConfig({ value: values?.fontFamily, name: `${name}.fontFamily`})} />
				</Col>
				<Col>
					<Field {...{ component: RenderField, className: 'font', label: 'Chữ khung'.t(), name: `${name}.text`, value: values?.text }} />
				</Col>
			</Row>
			
			<Row>
				<Col className={'d-flex align-items-center'} xs={'auto'} sx={{ minWidth: '80px !important'}}>
					{`qr:frame.fontSize`.t()}
				</Col>
				<Col className={'d-flex align-items-center'}>
					<Box {...{ sx: { width: '100%'} }}>
						<Field {...{
							className: clsx('slider', 'crop-slider', 'd-flex align-items-center'),
							onBlur: () => { }, onFocus: () => { },
							component: RenderSlider,
							onChange: setFieldValue,
							min: 50, max: maxFontSize || 200, step: 1,
							name: `${name}.fontSize`,
							value: values?.fontSize
						}} />
					</Box>
				</Col>
				<Col className={'d-flex align-items-center'} xs={'auto'} sx={{ width: '100px !important'}}>
					<Field {...{ component: RenderField, className: 'font',
						name: `${name}.fontSize`,
						value: values?.fontSize }} />
				</Col>
			</Row>
		</Box>
	</>)
}